<template>
  <div ref="swiper">
    <mt-swipe class="swiper1" :auto="7000" v-if="!list" @change="bannerChange">
      <template v-for="(img, index) in imgs">
        <mt-swipe-item class="swiper-item" :key="index" v-if="imgs.length > 0 && (img.is_show || $isTest)"
          ><img
            class="swiper-img"
            :src="img.ad_picture.indexOf('http') < 0 ? $imgBaseSrc + img.ad_picture : img.ad_picture"
            alt=""
            @click="chooseOne(img)"
          />
          <mt-swipe class="swiper" :auto="7000"></mt-swipe>
        </mt-swipe-item>
      </template>
    </mt-swipe>
    <mt-swipe class="swiper2" :auto="7000" v-if="list">
      <template v-for="(img, index) in list">
        <mt-swipe-item class="swiper-item" :key="index" v-if="img.is_show || $isTest"
          ><img
            class="swiper-img"
            :src="img.ad_picture.indexOf('http') < 0 ? $imgBaseSrc + img.ad_picture : img.ad_picture"
            alt=""
            @click="chooseOne(img)"
        /></mt-swipe-item>
      </template>
    </mt-swipe>
  </div>
</template>

<script>
import MaskBannerApis from '@/apis/maskservice/MaskBannerApis'

export default {
  props: {
    list: {
      type: Array
    },
    type: {
      type: Number
    }
  },
  data: function () {
    return {
      imgs: [],
      topbanner_flge: 0,
      bannerChange_flge: 0
    }
  },
  methods: {
    chooseOne(data) {
      // 统计点击次数
      if (data.id || data.id === 0) {
        window.axiosBaseApi.put(`/v1/advertisement/${data.id}`).then((res) => {})
      }
      // 跳转链接
      location.href = data.ad_url
    },
    elementInViewport() {
      let el = this.$refs.swiper
      let arry = el.getBoundingClientRect()
      let top = arry.top
      let left = arry.left
      let width = arry.width
      let height = arry.height
      while (el.offsetParent) {
        el = el.offsetParent
        top += el.offsetTop
        left += el.offsetLeft
      }
      return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        top + height <= window.pageYOffset + window.innerHeight &&
        left + width <= window.pageXOffset + window.innerWidth
      )
    },
    bannerChange(index) {
      this.topBannerShow = this.elementInViewport()
      if (this.topBannerShow) {
        window.maskBaseApi
          .get(`/advStatistics/statistics/ViewNum?advId=${this.imgs[Number(index)].id}&type=${this.type}&index=${index}`)
          .then((res) => {})
      }
      // console.log(this.topbanner_flge)
      // if (this.topbanner_flge >= 6) {
      //   this.bannerChange_flge = 0
      //   this.topbanner_flge = 0
      //   return
      // } else {
      //   this.topbanner_flge = 0
      // }
      // if (this.bannerChange_flge < 7) {
      //   this.bannerChange_flge = 0
      //   this.topbanner_flge = 0
      //   console.log(Number(index))
      //   console.log(this.imgs[Number(index) - 1])
      //   console.log(this.imgs[Number(index) - 1].title)
      //   window.axiosBaseApi.get(`http://192.168.1.27:8023/advStatistics/statistics/ViewNum?advId=${this.imgs[Number(index) - 1].id}&type=${this.type}`).then(res => {
      //     console.log('手动浏览请求成功')
      //   })
      // }
    }
  },
  created() {
    if (this.type === 1) {
      // 首页广告
      MaskBannerApis.getBanners({ type: this.type }).then((res) => {
        this.imgs = res.data
        window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.imgs[0].id}&type=${this.type}&index=0`).then((res) => {
          console.log('自动浏览请求成功')
        })
      })
    } else if (this.type === 2) {
      // 支付页广告
      window.axiosBaseApi.get(`/v1/carousel`).then((res) => {
        if (res.data.code === 1) {
          this.imgs = res.data.data
        } else {
          alert(res.data.msg)
        }
      })
    }
  },
  mounted() {
    // let vm = this
    // setInterval(function () {
    //   console.log(vm.bannerChange_flge)
    //   if (vm.bannerChange_flge === 7) {
    //     vm.bannerChange_flge = 0
    //   }
    //   vm.bannerChange_flge += 1
    //   vm.topBannerShow = vm.elementInViewport()
    //   console.log(vm.topBannerShow)
    //   if (vm.topBannerShow) {
    //     vm.topbanner_flge += 1
    //   } else {
    //     vm.topbanner_flge = 0
    //   }
    // }, 1000)
  }
}
</script>

<style lang="less">
.swiper1 {
  width: 100%;
  height: 4.56rem;
  background-color: #ccc;
  .swiper-item {
    .swiper-img {
      width: 100%;
      height: 100%;
    }
  }
}
.swiper2 {
  width: 100%;
  height: 1.8rem;
  background-color: #ccc;
  .swiper-item {
    .swiper-img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
